<script setup lang="ts">
import Popover, { type PopoverProps } from "primevue/popover";
import { useTemplateRef } from "vue";

export interface TaiPopoverComponentProps extends PopoverProps {}

const { dismissable = true } = defineProps<TaiPopoverComponentProps>();
const popoverRef = useTemplateRef("popover");

defineExpose({
  popoverRef
});
</script>

<template>
  <Popover
    v-bind="{ ...$props, ...$attrs }"
    :dismissable="dismissable"
    ref="popover"
  >
    <slot></slot>
  </Popover>
</template>
